<template>
  <!-- 视频详情页 -->
  <div style="width: 12.8rem; margin: 0.7rem auto 0">
    <div class="body_">
      <div class="body_left">
        <div class="body_left_video">
          <video-player id="myVideo" class="custom-video-player" ref="videoPlayer"
            :options="playerOptions"></video-player>
        </div>
        <div class="body_left_title">{{ list.title }}</div>
        <div class="body_left_click">
          <div @click="click_sc" style="cursor: pointer">
            <img :src="(list.isCollect == 0 || !list.isCollect)
              ? require('@/assets/music_b_SC.png')
              : require('@/assets/music_b_SC_OK.png')
              " />
            <span>收藏</span>
          </div>
          <div @click="click_fzlj" style="cursor: pointer">
            <img src="@/assets/scxx_fx.png" />
            <span>复制链接</span>
          </div>
          <div @click="module_informOverNo1" v-if="!report" style="cursor: pointer">
            <img src="@/assets/scxx_jb.png" />
            <span>举报</span>
          </div>
        </div>
        <div class="body_left_fl">
          <div v-for="index in list.typeNames" :key="index" style="">
            {{ index }}
          </div>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="body_left_xx">
              视频长度： <span>{{ list.playTime }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="body_left_xx">
              音频字体：
              <span>
                无
              </span>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="body_left_xx">
              视频ID： <span>{{ list.code }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="body_left_xx">
              更新时间： <span>{{ list.updateTime }}</span>
            </div>
          </el-col>
        </el-row>
        <div class="body_left_xx">
          使用限制：
          <span>
            无
            <!-- 供稿人上传作品中如含有的国旗国徽等党政图案仅作为整体效果示例展示，对于该类内容请创作人务必遵循法律法规的规定使用。 -->
          </span>
        </div>
        <!-- <div class="body_left_video">
          <video-player
            class="custom-video-player"
            ref="videoPlayer"
            :options="playerOptions"
          ></video-player>
        </div> -->
      </div>

      <div class="body_right">
        <!-- 选项卡 -->
        <div class="BR_Tab" v-if="list.selfPrice">
          <span @click="BR_TabClick(index, i)" v-for="(index, i) in tabList" :key="index"
            :class="index.checked ? 'BR_TabY' : 'BR_TabF'">{{ index.title }}</span>
        </div>
        <div class="BR_Tab" v-else>
          <span @click="BR_TabClick(index, i)" v-for="(index, i) in tabList1" :key="index"
            :class="index.checked ? 'BR_TabY' : 'BR_TabF'">{{ index.title }}</span>
        </div>
        <div class="BR_Tab_price">
          <span v-if="selectPrice == 0">{{
            list.selfPrice ? "￥" + (list.selfPrice / 1).toFixed(2) : "免费"
          }}</span>
          <span v-if="selectPrice == 1">{{
            list.enterPrice ? "￥" + (list.enterPrice / 1).toFixed(2) : "免费"
          }}</span>
          <span v-if="selectPrice == 2">{{
            list.enterPlusPrice
            ? "￥" + (list.enterPlusPrice / 1).toFixed(2)
            : "免费"
          }}</span>
          <!-- <div>会员专享价 ￥40.00</div> -->
        </div>
        <div class="BR_Tab_message">
          {{ list.resolutionRate && list.resolutionRate }}
          &nbsp; {{ list.frameRate && "@" + list.frameRate + "fps" }}
          <span v-if="list.resolutionRate || list.frameRate"></span>
          {{ list.fileExt }}
          <span v-if="list.bitRate"></span>
          {{ list.bitRate && list.bitRate / 1000 + "Kbps" }}
          <span></span>
          {{ list.fileSize }}
          <!-- {{ list.Shop }} -->
        </div>
        <div class="BR_Tab_xz">
          <div class="download" v-if="list.Shop" @click="popZj">下载</div>
          <div class="download" v-else @click="downloadClick">下载</div>
          <div class="shopping" v-if="list.Shop && list.selfPrice != 0" @click="popZj">
            加入购物车
          </div>
          <div class="shopping" v-else-if="list.selfPrice != 0" @click="shoppingTrolley">
            加入购物车
          </div>
        </div>
        <!-- <div class="BR_Tab_hy">
					<div class="BR_Tab_hy_left">
						会员免费下载
					</div>
					<div class="BR_Tab_hy_right">
						<div>升级会员</div>
						<div>获取下载次数</div>
					</div>
				</div> -->
        <div class="BR_Tab_Details">
          <div class="BR_Tab_Details_top">
            <div class="BR_TDT_left">视频素材用途</div>
            <div class="BR_TDT_right">
              <span style="margin-right: 0.12rem">授权范围</span>
              <span>授权书范本</span>
            </div>
          </div>
          <div class="BR_TDM">
            <div class="BR_TDM_" v-for="(item, index) in use_list">
              <div v-if="selectPrice == 0">
                {{ item.dictLabel }}
              </div>
              <div v-else-if="selectPrice != 0 && index > 1">
                {{ item.dictLabel }}
              </div>
              <div v-if="selectPrice == 0">
                <img style="width: 0.2rem" v-if="index > 1" src="../../assets/scxx_no.png" />
                <img style="width: 0.2rem" v-else src="../../assets/scxx_ok.png" />
              </div>
              <div v-if="selectPrice == 1">
                <img style="width: 0.2rem" v-if="index > 5" src="../../assets/scxx_no.png" />
                <img style="width: 0.2rem" v-else-if="index > 1" src="../../assets/scxx_ok.png" />
              </div>
              <div v-if="selectPrice == 2">
                <img v-if="index > 1" style="width: 0.2rem" src="../../assets/scxx_ok.png" />
              </div>
            </div>
          </div>
        </div>

        <div class="br_main" @click="Composer(list.createUser)">
          <img style="height: 0.8rem; border-radius: 50%"
            :src="list.avatar ? list.avatar : require('../../assets/logo.png')" />
          <div class="br_main_user">
            <span>{{ list.createUserName }}</span>
            <!-- <img
              style="margin-right: 0.06rem"
              src="../../assets/publick_huiyuan.png"
            /> -->
            <!-- <img src="../../assets/publick_huiyuan2.png" /> -->
          </div>
          <view style="display: flex; justify-content: center; padding: 0.18rem 0">
            <view class="wVC_list_l_T_B_rz" v-if="userList.professionalStatus == 2">
              <img src="../../assets/bvlv_blue.png" />
              标识山西认证{{ userList.profess }}
            </view>
          </view>
          <div class="br_main_click">
            <div class="BDC_gz" @click.stop="attention">
              {{ userList.isFollow ? "取消关注" : "关注" }}
            </div>
            <!-- <div class="BDC_lxhz" @click.stop="Contact(userList.memberId)">
              联系合作
            </div> -->
          </div>
          <div class="br_main_location">
            <img src="../../assets/bvlv_zb.png" />
            {{ userList.realDAddress || "暂无具体地址" }}
          </div>
        </div>
      </div>
    </div>
    <div class="body_list">
      <div>
        <div class="SL_hotSongwriter">
          <div class="SL_hotSongwriter_title">作者其他素材</div>
          <!-- <div class="SL_hotSongwriter_click">
						查看全部 >
					</div> -->
        </div>
        <img v-if="videoList.length == 0" class="zwsj" src="../../assets/zt_zanwushuju.png" />

        <el-row :gutter="20" v-else>
          <el-col :span="6" v-for="index in videoList" :key="index">
            <moduleProvideMaterial :collectIds="collectIds" @click="goParticulars(index)" class="SL_offerMaterialListdiv"
              :message="index"></moduleProvideMaterial>
          </el-col>
        </el-row>
      </div>
      <div>
        <div class="SL_hotSongwriter">
          <div class="SL_hotSongwriter_title">相似素材</div>
        </div>
        <img class="zwsj" v-if="videoLikenessList.length == 0" src="../../assets/zt_zanwushuju.png" />

        <el-row :gutter="20" v-else>
          <el-col :span="6" v-for="index in videoLikenessList" :key="index">
            <moduleProvideMaterial :collectIds="collectIds" @click="goParticulars(index)" class="SL_offerMaterialListdiv"
              :message="index"></moduleProvideMaterial>
          </el-col>
        </el-row>
      </div>
    </div>
    <view v-if="module_informChecked" class="module_inform">
      <view class="module_inform_body">
        <view class="module_share_body_top">
          <view>选择举报理由</view>
          <img @click="module_informOverNo" src="@/assets/module_share_open.png" />
        </view>
        <view>
          <view>
            <el-radio-group v-model="type">
              <el-row :gutter="20">
                <el-col :span="8"><el-radio label="1">违法违禁</el-radio></el-col>
                <el-col :span="8"><el-radio label="2">政治敏感</el-radio></el-col>
                <el-col :span="8"><el-radio label="3">色情低俗</el-radio></el-col>
                <el-col :span="8"><el-radio label="4">人身攻击</el-radio></el-col>
                <el-col :span="8"><el-radio label="5">垃圾广告</el-radio></el-col>
                <el-col :span="8"><el-radio label="6">刷屏</el-radio></el-col>
                <el-col :span="8"><el-radio label="7">其他问题</el-radio></el-col>
              </el-row>
            </el-radio-group>
          </view>
          <textarea placeholder="请输入举报内容" maxLength="100" v-model="reason" class="module_share_textarea"></textarea>
          <view class="module_share_button">
            <button class="module_share_button_Y" @click="handleReport">
              确定
            </button>
            <button class="module_share_button_N" @click="module_informOverNo">
              取消
            </button>
          </view>
        </view>
      </view>
    </view>
    <el-dialog title="" :show-close="false" v-model="payment" align-center width="4.8rem" :close-on-click-modal="false">
      <div class="zf_body">
        <div class="zf_body_top">
          <span>联系合作</span>
          <img @click="payment = false" class="cur" src="../../assets/module_share_open.png" />
        </div>
        <div class="zf_body_title">支付相应费用，获得联系方式</div>
        <div class="zf_b_M">
          <span CLASS="zf_b_M_title">应付金额：</span>
          <span class="zf_b_M_number"><text class="zf_b_M_n_icon">￥</text>{{ (moenyNumber / 1).toFixed(2) }}</span>
        </div>
        <div class="zf_fs_body">
          <div class="zf_fs_title">选择付款方式</div>
          <div class="zf_fs_list">
            <div v-for="index in paymentTypeList" :key="index" @click="paymentTL_click(index)">
              <img class="zf_fs_logo cur" :src="index.img" />
              <span>{{ index.title }}</span>
              <img v-if="index.checked" class="zf_fs_icon" src="../../assets/lxhz_icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="zf_fs_b">
          <div class="zf_fs_b_qx cur" @click="payment = false">取消</div>
          <div class="zf_fs_b_qd cur" @click="get_sjh(userList.memberId)">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-model="PartnersMobileNumber" align-center width="480px" :close-on-click-modal="false">
      <div style="text-align: center">联系方式</div>
      <div style="text-align: center; padding-top: 5px; font-size: 20px">
        {{ PartnersMobileNumber1 }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="PartnersMobileNumber = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="PartnersMobileNumber = false">
          确认
        </div>
      </div>
    </el-dialog>
    <two-dimensional-code ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElTable } from "element-plus";
import moduleProvideMaterial from "../../components/moduleProvideMaterial.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";
const TwoDimensionalCodeRef = ref<any>();
const router = useRouter();
const module_informChecked = ref(false);
const reason = ref("");
const type = ref("");
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
//不能购买自己
const popZj = () => {
  ElMessage.warning("不能购买自己");
};
//支付金额
let moenyNumber = ref(0);
// 支付类型切换
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    img: require("../../assets/lxhz_wx.png"),
    checked: true,
  },
  {
    title: "支付宝",
    img: require("../../assets/lxhz_zfb.png"),
    checked: false,
  },
]);
let paymentTL_click = function (index) {
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};

const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/member/contacts/phone/" + e,
    {},
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) { }
  );
};
let payment = ref(false);
// 获取联系合作 // index 回去对象的的id
let Contact = function (index) {
  Axios(
    "get",
    "/member/contacts/phone/" + index,
    {},
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
    },
    function (res) {
      ElMessage({
        showClose: true,
        message: res.data.msg,
        type: "warning",
      });
      console.log(res.data.data);

      getMoney();
    }
  );
};
//获取金额
let getMoney = function () {
  Axios("get", "/member/contacts/pay-amount", {}, false, function (res) {
    moenyNumber.value = res.data.msg;
    payment.value = true;
  });
};
// 支付获取联系方式
let get_sjh = function (index) {
  Axios(
    "POST",
    "/member/contacts?memberId=" + index,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${index}`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            index
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
let id = router.currentRoute.value.query.id;
/* 获取当前数据接口 */
let list = ref({});
let use_list = ref([]);
let userList = ref([]);
let report = ref(false);
let getuserMassage = function (id) {
  console.log(id);
  Axios("GET", "/member/info/" + id, false, false, function (res) {
    userList.value = res.data.data;
    console.log(res.data);
  });
};
document.title = "标识山西-找素材-视频素材";
const getList = function () {
  Axios("get", "/fodder/info/" + id, false, false, function (res) {
    console.log("res.data.data", res.data.data.createUser);
    if (JSON.parse(localStorage.getItem("userList"))) {
      res.data.data.createUser ==
        JSON.parse(localStorage.getItem("userList")).memberId
        ? (res.data.data.Shop = true)
        : (res.data.data.Shop = false);
    } else {
      res.data.data.Shop = false;
    }

    list.value = res.data.data;
    let a = localStorage.getItem("userList") != null ? JSON.parse(localStorage.getItem("userList")).memberId : "";
    report.value = list.value.createUser == a;
    playerOptions.value.sources[0].src = res.data.data.filePath;
    let uses = res.data.data.uses;
    document.title += res.data.data.title;
    videoUse(uses);
    user_other();
    likeness_other();
    getuserMassage(list.value.createUser);
  });
};
getList();
const module_informOverNo = () => {
  module_informChecked.value = false;
  type.value = "";
  reason.value = "";
};
const module_informOverNo1 = () => {
  module_informChecked.value = true;
};
const handleReport = function () {
  if (!type.value) {
    ElMessage.warning("请选择举报类型");
    return;
  }
  Axios(
    "POST",
    "/fodder/report",
    { materialId: id, remark: type.value },
    null,
    false,
    function (res) {
      ElMessage.success("举报成功");
      module_informChecked.value = false;
      // emit("openClickOverOpen");
    }
  );
};
const videoUse = (uses) => {
  Axios("get", "/fodder/video-use", false, false, function (res) {
    res.data.data.forEach((item, index) => {
      if (uses) {
        const result = Object.values(item).some((val) => {
          console.log(val);
          uses.includes(val);
        });
        console.log("result", result);

        if (result) {
          item.show = true;
        } else {
          item.show = false;
        }
      } else {
        item.show = false;
      }
    });
    use_list.value = res.data.data;
  });
};

// console.log(JSON.parse(localStorage.getItem("userList")), "登录信息");

const tabList = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
  {
    title: "企业授权",
    authType: "ENTERPRISE",
    checked: false,
  },
  {
    title: "企业Plus",
    authType: "UNION",
    checked: false,
  },
]);
const tabList1 = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
]);
const tabListType = ref("SELF");
const selectPrice = ref(0);
const BR_TabClick = function (index, arrI) {
  selectPrice.value = arrI;
  for (let i = 0; i < tabList.value.length; i++) {
    if (tabList.value[i] == index) {
      tabList.value[i].checked = true;
      tabListType.value = tabList.value[i].authType;
    } else {
      tabList.value[i].checked = false;
    }
  }
};
/*作者其它作品*/
const videoList = ref([]);
const user_other = () => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "VIDEO",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 4,
      materialId: id,
      memberId: list.value.createUser,
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        videoList.value = [];
      } else {
        let new_srcList = res.data.rows;
        setTimeout(() => {
          videoList.value = new_srcList;
        }, 200);
      }
    }
  );
};

/*相似类型*/
const videoLikenessList = ref([]);
const likeness_other = () => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "VIDEO",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 8,
      materialId: id,
      typeIds: list.value.typeIds,
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        videoLikenessList.value = [];
      } else {
        let new_srcList = res.data.rows;
        setTimeout(() => {
          videoLikenessList.value = new_srcList;
        }, 200);
      }
    }
  );
};
/* 加入购物车 */
const shoppingTrolley = function () {
  Axios(
    "POST",
    "/fodder/car",
    {
      materialId: list.value.id,
      authType: tabListType.value,
    },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
/* 下载 */
const downloadClick = function () {
  Axios(
    "GET",
    "/fodder/down",
    {
      materialId: id,
    },
    false,
    function (res) {
      router.push({
        path: "/purchasedMaterial",
      });
    },
    function (res) {
      if (res.data.code == 100) {
        Axios("get", "/fodder/order/check/" + id, {}, false, (res) => {
          router.push({
            path: "/myOrderDetial",
            query: {
              arry: id,
              authType: tabListType.value,
              totalPay: 0,
              type: "order",
            },
          });
        });
      }
    }
  );
};
const allWorksClick = function () {
  router.push({
    path: "/ShadowMaterialVideoList",
  });
};

const playerOptions = ref({
  autoplay: false,
  controls: true,
  muted: false,
  controlBar: {
    durationDisplay: true,
    volumePanel: {
      inline: false,
    },
  },
  sources: [
    {
      src: "",
      type: "video/mp4",
    },
  ],
});
//关注/取消关注
let attention = function () {
  if (userList.value.isFollow == false) {
    Axios(
      "POST",
      "/member/member-follow",
      {
        memberId: userList.value.memberId,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "关注成功",
          type: "success",
        });
        getuserMassage(userList.value.memberId);
      }
    );
  } else {
    Axios(
      "DELETE",
      "/member/member-follow",
      {
        memberId: userList.value.memberId,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消关注",
          type: "success",
        });
        getuserMassage(userList.value.memberId);
      }
    );
  }
};
// 视频详情
const goParticulars = function (index) {
  console.log(index.id);

  router
    .push({
      path: "/ShadowMaterialVideoParticulars",
      query: {
        id: index.id,
      },
    })
    .then(() => {
      location.reload();
    });
};
// 创作人跳转
const Composer = function (id) {
  router.push({
    path: "/ShadowComposerHomepage",
    query: {
      id: id,
    },
  });
};
// 搜藏
let click_sc = function () {
  // --收藏
  if (list.value.isCollect == 0) {
    Axios(
      "post",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已收藏",
          type: "success",
        });
        getList();
      }
    );
  } else {
    //  --取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
        getList();
      }
    );
  }
};
// 复制链接
const click_fzlj = function () {
  navigator.clipboard.writeText(window.location.href).then(() => {
    ElMessage({
      showClose: true,
      message: "复制成功",
      type: "success",
    });
  });
};
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
getCollects();
</script>

<style scoped lang="less">
.zwsj {
  width: 4rem;
  display: block;
  margin: 0 auto;
}

.body_ {
  width: 100%;
  display: flex;
  /* justify-content: ; */
}

.body_left {
  flex-grow: 1;
}

.body_left_video {
  height: 4.84rem;

  background: #0f0;
}

/deep/.custom-video-player,
/deep/.video-js {
  width: 100% !important;
  height: 4.84rem !important;
}

.body_right {
  width: 3.8rem;
  margin-left: 0.4rem;
}

.BR_Tab {
  display: flex;
  justify-content: space-evenly;
}

.BR_Tab {
  padding: 0.16rem 0;
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
}

.BR_Tab>span {
  padding-bottom: 0.16rem;
}

.BR_TabY {
  border-bottom: 0.02rem solid #c01a26;
}

.BR_TabF {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0d);
}

.BR_Tab_price {
  display: flex;
  align-items: center;
  margin-bottom: 0.12rem;
}

.BR_Tab_price>span {
  color: #c01a26;
  font-size: 0.32rem;
  margin-right: 0.16rem;
}

.BR_Tab_price>div {
  padding: 0.04rem 0.12rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: linear-gradient(90deg, #feebd7 0%, #f8bba6 100%);
  color: #be5720;
  font-size: 0.16rem;
  font-weight: 400;
}

.BR_Tab_message {
  color: #86909c;
  font-size: 0.12rem;
  display: flex;
  margin-bottom: 0.2rem;
}

.BR_Tab_message>span {
  width: 0.01rem;
  height: 0.15rem;
  background: #86909c;
  margin: 0 0.08rem;
}

.BR_Tab_xz {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0.2rem;
  cursor: pointer;
}

.shopping {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  border: 0.01rem solid #c01a26;
  padding: 0.12rem 0.16rem;
  color: #c01a26;
  font-size: 0.14rem;
  margin-left: 0.1rem;
  cursor: pointer;
}

.download {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #c01a26;
  color: #ffffff;
  font-size: 0.14rem;
  flex-grow: 1;
  text-align: center;
  padding: 0.12rem;
}

/* 	.BR_Tab_hy {
		display: flex;
		border-radius: 0.08rem;
		overflow: hidden;
		align-items: center;
		margin-bottom: 0.2rem;
	}

	.BR_Tab_hy_left {
		flex-grow: 1;
		font-size: 0.14rem;
		color: #FCE5CC;
		background: linear-gradient(180deg, #5C4947 0%, #2F2322 100%);
		padding: 0.1rem 0;
		text-align: center;
	}

	.BR_Tab_hy_right {
		padding: 0.04rem 0.16rem;
		font-size: 0.12rem;
		color: #5E2D11;
		background: linear-gradient(135deg, #F4DCC3 0%, #E5B496 100%);
	}

	.BR_Tab_hy_right>div {
		text-align: center;
	} */

.BR_Tab_Details_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.16rem;
}

.BR_TDT_left {
  color: #000000;
  font-size: 0.16rem;
}

.BR_TDT_right {
  color: #86909c;
  font-size: 0.12rem;
}

.BR_TDM_ {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.12rem;
}

.BR_TDM_>div {
  font-size: 0.14rem;
  color: #333333;
}

.BR_TDM_ span {
  color: #c01a26;
}

.BR_TDM_>img {
  width: 0.2rem;
}

.body_left_title {
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 0.08rem;
  margin-top: 0.2rem;
  line-height: 0.28rem;
}

.body_left_click {
  display: flex;
  align-items: center;
  margin-bottom: 0.24rem;
}

.body_left_click>div {
  margin-right: 0.24rem;
  font-size: 0.14rem;
  color: #333333;
  display: flex;
  align-items: center;
}

.body_left_click>div>img {
  width: 0.2rem;
}

.body_left_click>div>span {
  margin-left: 0.03rem;
}

.body_left_fl {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 0.2rem;
  margin-bottom: 0.2rem;
  border-bottom: 0.01rem solid #e5e6eb;
}

.body_left_fl>div {
  color: #86909c;
  margin-top: 0.12rem;
  // display: block;
  // flex: none;
  font-size: 0.12rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f2f3f5;
  padding: 0.04rem 0.12rem;
  margin-right: 0.12rem;
}

.body_left_xx {
  font-size: 0.14rem;
  color: #86909c;
  margin-bottom: 0.12rem;
}

.body_left_xx>span {
  color: #333333;
  font-size: 0.14rem;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  position: relative;
  margin-bottom: 0.3rem;
  display: block;
  overflow: hidden;
  height: 1.7rem;
}

.br_main {
  border: 0.01rem solid #e5e6eb;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.24rem 0;
}

.br_main>img {
  width: 0.8rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.16rem;
}

.br_main_user {
  display: flex;
  color: #000000;
  font-size: 0.14rem;
  justify-content: center;
}

.br_main_user>img {
  height: 0.16rem;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.13rem;
  margin-right: 0.09rem;
}

.br_main_location {
  color: #333333;
  font-size: 0.14rem;
  border-top: 0.01rem solid #e5e6eb;
  padding-top: 0.19rem;
}

.br_main_location>img {
  width: 0.13rem;
  margin-right: 0.06rem;
  margin-left: 0.17rem;
}

.br_main_click {
  display: flex;
  justify-content: center;
  margin-bottom: 0.16rem;
}

.br_main_click>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
}

.BDC_gz {
  margin-right: 0.2rem;
  color: #333333;
  border: 0.01rem solid #86909c;
  background: #fff;
  cursor: pointer;
}

.BDC_lxhz {
  background: #c01a26;
  color: #fff;
  cursor: pointer;
}

.module_inform {
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: saturate(21%) blur(3px);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.module_inform_body {
  width: 4.36rem;
}

.module_share_textarea {
  width: 100%;
  resize: none;
  padding: 0.12rem 0.16rem;
  color: #86909c;
  font-size: 0.14rem;
  height: 1.04rem;
  border-radius: 0.12rem;
  margin-top: 0.32rem;
  margin-bottom: 0.2rem;
}

.module_share_button {
  display: flex;
  justify-content: center;
}

.module_share_button>button {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;

  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
}

.module_share_button_Y {
  margin-right: 0.2rem;
  border: 0.01rem solid #333333;
  color: #333;
}

.module_share_button_N {
  color: #fff;
  background: #c01a26;
  border: 0rem solid #fff;
}

.module_share_body,
.module_inform_body {
  background: #ffffff;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.17rem 0.24rem;
}

.module_share_body_top,
.module_share_main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.21rem;
}

.module_share_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.module_share_body_top>img {
  width: 0.2rem;
}

.module_share_main {
  border-bottom: 0.01rem solid #e5e6eb;
  padding-bottom: 0.2rem;
}

.module_share_main>img {
  width: 3.8rem;
  margin-right: 0.4rem;
}

.module_share_main_title {
  text-align: center;

  font-size: 0.14rem;
  color: #333333;
  line-height: 0.16rem;
}

.module_share_main_list {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.16rem;
}

.module_share_main_list>img {
  width: 0.4rem;
}

.no_data {
  width: 100%;
  height: 160px;
}

.zf_body {
  border-radius: 0.12rem;
}

.zf_body_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.zf_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.zf_body_top>img {
  width: 0.2rem;
}

.zf_body_title {
  color: #86909c;
  font-size: 0.14rem;
  text-align: center;
  margin-bottom: 0.12rem;
}

.zf_b_M {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.zf_b_M_title {
  font-size: 0.14rem;
  color: #000000;
}

.zf_b_M_number {
  font-size: 0.24rem;
  color: #c01a26;
}

.zf_b_M_n_icon {
  font-size: 0.14rem;
}

.zf_fs_body {
  margin-top: 0.2rem;
}

.zf_fs_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.12rem;
}

.zf_fs_list {
  display: flex;
}

.zf_fs_list>div {
  position: relative;
  border-radius: 0.04rem;
  border: 1px solid #e5e6eb;
  padding: 0.08rem 0.24rem;
  margin-right: 0.12rem;
  display: flex;
  align-items: center;
}

.zf_fs_logo {
  width: 0.24rem;
  margin-right: 0.04rem;
}

.zf_fs_icon {
  width: 0.25rem;
  position: absolute;
  right: 0;
  bottom: 0;
}

.zf_fs_b {
  display: flex;
  justify-content: center;
}

.zf_fs_b>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem;
  border: 0.01rem solid #333333;
}

.zf_fs_b_qx {
  color: #333333;
}

.zf_fs_b>.zf_fs_b_qd {
  color: #ffffff;
  border: 0.01rem solid #c01a26;
  background: #c01a26;
  margin-left: 0.2rem;
}

.zf_fs_body {
  margin-bottom: 0.2rem;
}

/deep/.el-dialog__header {
  padding: 0 !important;
}

.brt_list {
  display: flex;
}

.top_click_list>div {
  padding: 0.08rem 0.16rem;
  border-radius: 0.08rem;
  font-size: 0.14rem;
  margin-right: 0.2rem;
}

.top_click_listT {
  border: 0.01rem solid #c01a26;
}

.top_click_listF {
  border: 0.01rem solid rgba(0, 0, 0, 0);
}
</style>
